module.exports = __webpack_public_path__ + "static/scroll_heatmap_dashboard-5c2c79ec2e8728b90de33d4e9881eb33.jpg";